import _ from '../../core/utils'
import HEADER_CONFIG from './config'
import { gsap } from 'gsap'

class HeaderClass {
    constructor() {
        this.DOM = {
            el: HEADER_CONFIG.el,
            background: HEADER_CONFIG.background,
            hamburger: HEADER_CONFIG.hamburger,
            hamburgerLines: HEADER_CONFIG.hamburgerLines,
            nav: HEADER_CONFIG.nav,
            pages: HEADER_CONFIG.pages,
            socialmedia: HEADER_CONFIG.socialmedia
        }

        this.treshold = HEADER_CONFIG.treshold
        this.y = window.scrollY
        this.direction = null
        this.state = false
        this.init()
    }

    init() {
        this.DOM.el ? this._listeners() : null
        console.log( this )
    }

    _listeners() {
        this.DOM.hamburger.addEventListener( 'click', this._state.bind( this ) )
        window.addEventListener( 'scroll', this._scrollPosition.bind( this ) )
    }

    _scrollPosition( event ) {
        window.scrollY > this.y ? this.direction = 'down' : this.direction = 'up'
        this.y = window.scrollY
        
        this._headerVisibility()
    }
    _headerVisibility() {
        this.direction == 'down' && this.y > this.treshold ? this._headerHide() : null
        this.direction == 'up' && this.y <= this.treshold ? this._headerShow() : null
        this.y <= this.treshold ? this._headerTop() : this._headerNotTop()
    }
    _headerHide() {
        _.addClass( this.DOM.el, 'header--hide' )
    } 
    _headerShow() {
        _.removeClass( this.DOM.el, 'header--hide' )
    }
    _headerTop() {
        _.addClass( this.DOM.el, 'header--top' )
    }
    _headerNotTop() {
        _.removeClass( this.DOM.el, 'header--top' )
    }
    _state() {
        this.state = !this.state
        this.state ? this._showNav() : this._hideNav()
    }

    _hideNav() {
        let tl = gsap.timeline()
        tl.to( document.documentElement, {
            overflow: 'initial',
            duration: 0
        }, 'first' )
        tl.to( this.DOM.hamburgerLines[0], {
            rotate: 0,
            y: 0,
            duration: .1
        }, 'first' )
        tl.to( this.DOM.hamburgerLines[1], {
            rotate: 0,
            y: 0,
            duration: .1
        }, 'first' )
        tl.to( this.DOM.background, {
            opacity: 1,
            duration: .3
        }, 'first' )
        tl.to( this.DOM.nav, {
            opacity: 0,
            pointerEvents: 'none',
            duration: .4
        }, 'first' )
        tl.to( this.DOM.pages, {
            opacity: 0,
            y: '-10%',
            duration: .1
        }, 'first')
        tl.to( this.DOM.socialmedia, {
            opacity: 0,
            y: '-10%',
            duration: .1
        }, 'first')
        tl.to( this.DOM.nav, {
            y: '-100%',
            duration: 0
        }, 'second' )
    }

    _showNav() {
        let tl = gsap.timeline()
        tl.to( document.documentElement, {
            overflow: 'hidden',
            duration: 0
        }, 'first' )
        tl.to( this.DOM.hamburgerLines[0], {
            rotate: 45,
            y: 6,
            duration: .1
        }, 'first' )
        tl.to( this.DOM.hamburgerLines[1], {
            rotate: -45,
            y: -6,
            duration: .1
        }, 'first' )
        tl.to( this.DOM.background, {
            opacity: 0,
            duration: .1
        }, 'first' )
        tl.to( this.DOM.nav, {
            opacity: 1,
            y: '0%',
            pointerEvents: 'auto',
            duration: .2
        }, 'first' )
        tl.to( this.DOM.pages, {
            opacity: 1,
            y: '0%',
            stagger: .05
        }, 'second' )
        tl.to( this.DOM.socialmedia, {
            opacity: 1,
            y: '0%',
            duration: .1
        }, 'second' )
    }
}

const HEADER = new HeaderClass()
export default HEADER